import { Button, Div, Span, Tooltip, TooltipTrigger } from "@hopper-ui/components";
import { QuestionIcon } from "@hopper-ui/icons";
import { useMemo, type PropsWithChildren, type ReactElement } from "react";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";

interface Props {
    tooltip?: string | ReactElement;
}
export const FormFieldLabel = ({ children, tooltip }: PropsWithChildren<Props>) => {
    const { tShared } = useSharedTranslation();
    const hasTooltip = useMemo(() => !!tooltip, [tooltip]);

    return (
        <Div position="relative" marginRight={hasTooltip ? "inline-lg" : 0}>
            {children}
            {hasTooltip &&
                <Span position="absolute" marginLeft="inline-sm" marginTop="core_40">
                    <TooltipTrigger>
                        <Button variant="ghost-secondary" size="sm" height="auto" padding="core_0" type="button" aria-label={tShared("moreInformation")}>
                            <QuestionIcon color="neutral-weak" size="sm" />
                        </Button>
                        <Tooltip
                            textAlign="center"
                            UNSAFE_maxWidth="19.375rem"
                        >
                            {tooltip}
                        </Tooltip>
                    </TooltipTrigger>
                </Span>
            }
        </Div>
    );
};
